import { createCss, StitchesCss } from "@stitches/react";
import { BLOCK_Z_UPPERBOUND, NAV_BAR_HEIGHT } from "./consts";

export const brown = "rgb(105,65,65)";
const stitchesConfig = createCss({
  prefix: "",
  theme: {
    colors: {
      hyperlink: "rgb(0,0,255)",
      green: "rgb(101,195,102)",
      transparentBlack: "rgba(0,0,0,.8)",
      transparentWhite: "rgba(255, 255, 255, 0.9)",
      grey30: "rgba(30,30,30)",
      brown: brown,
      transparentBrown40: "rgba(105,65,65,0.4)",
      brightBeige: "rgba(245, 244, 242, 1)",
      beige: "rgba(240, 238, 232, 1)",
      menuBeige: "rgba(246, 245, 241,0.9)",
      grey225: "rgba(225,225,225)",
      menuTitleGray: "rgba(85,65,65,0.8)",

      transparentBlack03: "rgba(0, 0, 0, 0.03)",
      transparentBlack05: "rgba(0, 0, 0, 0.05)",
      transparentBlack10: "rgba(0, 0, 0, 0.10)",
      transparentBlack15: "rgba(0, 0, 0, 0.15)",
      transparentBlack25: "rgba(0, 0, 0, 0.25)",
      transparentWhite10: "rgba(255, 255, 255, 0.1)",

      lightRed: "#EC4D3D",
      darkenedRed1: "#C94134",
      darkenedRed2: "#B13A2E",
      inputBackground: "rgba(118,118,128,0.12)",
      buttonBlue: "#A3ECE9",
      buttonBlueDarker: "hsl(178, 66%, 68%)",
      buttonBlueDarkest: "hsl(178, 66%, 60%)",
      linkBlue: "#007AFF",
      toastGray: "#575757",
    },
    sizes: {
      1: "0.25rem",
      2: "0.50rem",
      3: "0.75rem",
      4: "1.00rem",
      5: "1.50rem",
      6: "2.00rem",

      navBarHeight: NAV_BAR_HEIGHT + "rem",
    },
    space: {
      1: "0.25rem",
      2: "0.50rem",
      3: "0.75rem",
      4: "1.00rem",
      5: "1.50rem",
      6: "2.00rem",

      buttonPadding: "0.375rem",
      navBarHeight: "3.00rem",
    },
    radii: {
      1: "0.25rem",
      2: "0.50rem",
      3: "0.75rem",
      4: "1.00rem",
      circle: "99rem",
    },
    fontSizes: {
      1: ".25rem",
      2: ".5rem",
      3: ".8rem",
      4: "1rem",
      5: "1.125rem",
      6: "1.5rem",
      7: "2.0rem",
    },
    lineHeights: {
      4: "1rem",
      5: "1.5rem",
    },
    fontWeights: {
      medium: "500",
    },
    fonts: {
      default:
        '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
    },
    zIndices: {
      navBar: "1", // Nav should be before Space in DOM order for a11y, but it's sibling to <Space> so cannot comingle with blocks/cursors
      blockContent: "20",
      blockOverlay: "30",
      blockPreview: BLOCK_Z_UPPERBOUND.toString(),
      cursor: (BLOCK_Z_UPPERBOUND + 10).toString(),
    },
    shadows: {
      cursor: "0 .1rem .3rem rgba(0,0,0,.25)", // FIXME: stitches doesnt properly support color tokens inside shadow definition
    },
  },
  media: {},
  utils: {
    backgroundBlur: (config) => (value) => ({
      backdropFilter: "blur(10px)",
    }),
  },
});

export const {
  styled,
  css,
  global,
  theme,
  keyframes,
  getCssString,
} = stitchesConfig;

export type CSS = StitchesCss<typeof stitchesConfig>;
